import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { WorkflowTemplateManifestDescriptor } from './model/workflow.template.manifest';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class WorkflowTemplateManifestService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'WorkflowTemplateManifestManagement',
      authService,
      config.WMSConfig
    );

  }

  public create(workflowTemplateManifest: WorkflowTemplateManifestDescriptor): Promise<WorkflowTemplateManifestDescriptor> {
    return super.post<WorkflowTemplateManifestDescriptor>(
      new WorkflowTemplateManifestDescriptor({
        id: undefined,
        href: undefined,
        workflowTemplateId: workflowTemplateManifest.workflowTemplateId,
        manifestType: workflowTemplateManifest.manifestType,
        size: workflowTemplateManifest.size,
        body: workflowTemplateManifest.body,
        modified: workflowTemplateManifest.modified,
        deleted: workflowTemplateManifest.deleted
      }));
  }

  public getWorkflowTemplateManifests(view?: View): Promise<List<WorkflowTemplateManifestDescriptor>> {
    return super.get<List<WorkflowTemplateManifestDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, workflowTemplateManifest: WorkflowTemplateManifestDescriptor): Promise<WorkflowTemplateManifestDescriptor> {
    return super.put<WorkflowTemplateManifestDescriptor>(id, workflowTemplateManifest);
  }

  public getById(id: string): Promise<WorkflowTemplateManifestDescriptor> {
    return super.get<WorkflowTemplateManifestDescriptor>(id);
  }

  public upload(id: string, files: Set<File>, doneCallback?: () => void, errorCallback?: (error) => void): { [key: string]: Observable<number> } {
    return this.auth.upload(this.buildUrl(id) + '/upload', files, doneCallback, errorCallback);
  }

  public download(id: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(id) + '/download');
  }

}




// WEBPACK FOOTER //
// ./src/app/modules/workflow.template.manifest/workflow.template.manifest.service.ts